/**
 * Standardized (canonical) user event names.
 *
 * These constants define the authoritative event identifiers used across the app.
 * They are pushed to the GTM dataLayer and consumed by GTM tags and triggers,
 * from where they are distributed to FB Pixel, G4A etc.
 *
 * Notes:
 * - Do not rename existing values without coordinating changes in GTM.
 */
export const UserEvent = {
  signedUp: "signed_up",
  verifiedEmail: "verified_email",
  generatedLead: "lead_generated",
  loggedIn: "logged_in",
  viewedProduct: "viewed_product",
  createdDraftProduct: "created_draft_product",
  publishedProduct: "published_product",
  firstPublishedProduct: "first_published_product",
  addedPaymentMethod: "added_payment_method",
  uploadedDesign: "uploaded_design",
  connectedStore: "connected_store",
  orderedSamples: "ordered_samples",
  placedManualOrder: "placed_manual_order",
  pageView: "pageview",
  purchase: "purchase",
  subscriptionPurchase: "subscription_purchase",
  seenWelcomeModal: "seen_welcome_modal",
} as const

export type UserEvent = (typeof UserEvent)[keyof typeof UserEvent]
